/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  user: 'Benutzer',
  users: 'Benutzer',
  name: 'Name',
  email: 'E-Mail',
  password: 'Passwort',
  passwordConfirmation: 'Passwort Bestätigung',
  admin: 'Admin',
  role: 'Rolle',
  actions: 'Aktionen',
  add: 'hinzufügen',
  edit: 'bearbeiten',
  save: 'speichern',
  saveSuccess: 'Benutzer erfolgreich gespeichert.',
  saveFailure: 'Benutzer konnte nicht gespeichert werden.',
  delete: 'löschen',
  deletePrompt: 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten??',
  deleteSuccess: 'Benutzer erfolgreich gelöscht.',
  deleteFailure: 'Benutzer konnte nicht gelöscht werden.',
  cancel: 'stornieren',
  search: 'suchen',
  emailAlreadyInUse: 'Die E-Mail-Adresse ist bereits in Gebrauch, bitte verwenden Sie eine andere.',
  passwordsMismatch: 'Die Passwörter stimmen nicht überein, bitte versuchen Sie es erneut.',
  nameRequired: 'Der Name ist erforderlich, bitte geben Sie einen Wert ein.',
  emailRequired: 'Die E-Mail ist erforderlich, bitte geben Sie einen Wert ein.',
  emailInvalid: 'Die E-Mail-Adresse ist ungültig, bitte geben Sie eine gültige E-Mail an.',
  passwordRequired: 'Das Passwort ist für neue Benutzer erforderlich, bitte geben Sie einen Wert ein.',
  listFailure: 'Benutzer konnten nicht aufgelistet werden, bitte versuchen Sie es erneut.',
  filterUsers: 'Benutzer filtern',
}
